<template>
    <div id="v-supplier-wrap">
        <!-- 顶部栏 -->
        <div class="head">
            <dl>
                <dt>
                    <img class="logo" :src="$config.resource + 'dhl_logo.png'" alt="">
                </dt>
                <!-- 头像信息 -->
                <dd>
                    <div class="portrait">
                        <img class="pic" :src="user.head" alt="">
                    </div>
                    <p>{{user.company_name}}</p>
                    <div class="quit" @click="onQuit">
                        <img class="icon" :src="$config.resource + 'tc.png'" alt="">
                    </div>
                </dd>
            </dl>
        </div>
        <!-- 主要部分 -->
        <div class="main_box">
            <!-- 步骤 -->
            <div class="step">
                <img class="pic_bg" :src="$config.resource + 'db_bjt.png'" alt="">
                <div class="row_box">
                    <div class="row curr">
                        <div class="circle">1</div>
                        <p>选择供应商类型</p>
                    </div>
                    <div class="wire white"></div>
                    <div class="row">
                        <div class="circle">2</div>
                        <p>企业概况</p>
                    </div>
                    <div class="wire"></div>
                    <div class="row">
                        <div class="circle">3</div>
                        <p>工厂概况</p>
                    </div>
                    <div class="wire"></div>
                    <div class="row">
                        <div class="circle">4</div>
                        <p>产品概况</p>
                    </div>
                    <div class="wire"></div>
                    <div class="row">
                        <div class="circle">5</div>
                        <p>提交</p>
                    </div>
                </div>
            </div>
            <!-- 供应商类型 -->
            <div class="Firstep" v-if="isSort">
                <div class="top_box">
                    <div class="pattern"></div>
                    <p>供应商类型</p>
                </div>
                <ul>
                    <li v-for="(item,index) in form" 
                        :key="index" 
                        @click="onchoice(item)" 
                        :class="{curr:choiceIndex == item.id}">{{item.name}}</li>
                </ul>
            </div>
            <div class="btn_box" v-if="isSort">
                <div class="btn gray" @click="onBack">上一步</div>
                <div class="btn red" v-if="isType==2" @click="onNext">下一步</div>
            </div>
            <!-- 供应商类型里的分类 -->
            <div class="classify" v-if="!isSort">
                <div class="top_box">
                    <div class="pattern"></div>
                    <p>{{name}}</p>
                </div>
                <ul>
                    <li v-for="(item,index) in genre" 
                        :key="index" 
                        @click="onChecked(item.id)" 
                        :class="{curr:checkedIndex == item.id}">{{item.name}}</li>
                </ul>
            </div>
            <div class="btn_box" v-if="!isSort">
                <div class="btn gray" @click="onUp">上一步</div>
                <div class="btn red" v-if="isType!=2" @click="onSubmit">下一步</div>
                <div class="btn red" v-if="isType==2" @click="toViewPage('/enterprise',{type:2})">下一步</div>
            </div>
        </div>
        <!-- 弹窗 -->
        <!-- 未填写提示 -->
        <div class="popup" v-if="isNot">
            <div class="Masked"></div>
            <div class="hint_box">
                <div class="top_box">
                    <div class="pattern"></div>
                    <p>提示</p>
                </div>
                <div class="content">
                    <p v-html="v"></p>
                    <!-- <p>机加类 机加厂家：来图加工，如CNC，车铣磨，不含纯机架、 钣金加工。</p>
                    <p>钣金厂家：来图加工，只生成支架、机架、钣金。</p>
                    <p>外协厂家：来图来料加工，表面处理，工序委外。</p>
                    <p>外购类 生产厂家：自己设计、生产、销售的厂家（标注件）</p>
                    <p>代理商：有代理证或授权证书。</p>
                    <p>贸易商：无代理证或授权证书。</p>
                    <p>项目类：工位、整机设计，工位、整机设计组装。</p>
                    <p>服务类：人力资源，安保，餐饮，厂区、设备保养等。</p>
                    <p>工程类 基建类：基础设施建设，土地工程等。</p> -->
                </div>
                <div class="btn" @click="onShut">已了解</div>
            </div>
        </div>
        <!-- 已填写提示 -->
        <div class="popup" v-if="isFilled">
            <div class="Masked"></div>
            <div class="hint_box">
                <div class="top_box">
                    <div class="pattern"></div>
                    <p>提示</p>
                </div>
                <div class="content">
                    <p>贵公司填写的内容已通过审核</p>
                    <p>仅可查看先前填写或选择的内容与查看上传的文档</p>
                    <p>不可修改任何信息和上传文档</p>
                </div>
                <div class="btn" @click="onShut">点击查看</div>
            </div>
        </div>
    </div>
</template>
<script>
    import store from '../vuex/store.js';
    export default {
        data(){
            return{
                user:'',// 用户信息
                isType:'',// 1.提交下一步 2.详情下一步

                v:'',// 提示容器
                choiceIndex:'', // 供应商类型 
                form:[],// 供应商类型
                name:'',// 供应商类型名称
                checkedIndex:'',// 供应商类型里的分类
                genre:[],// 供应商类型里的分类
                isSort:true,// 分类显示隐藏
                isNot:false,// 未填写弹窗
                isFilled:false,// 已填写弹窗
            }
        },
        store,
        methods: {
            //页面跳转
            toViewPage($path,$query) {
                this.$jump.toViewPage(this,$path,$query)
            },
            // 选择供应商类型
            onchoice(item){
                this.choiceIndex = item.id
                this.name = item.name
                this.genre = item.son
                console.log('打印',this.choiceIndex)
                if(this.isType!=2){
                    if(this.choiceIndex!=''){
                        this.isSort = false 
                    }else{
                        this.$dialog.toast({
                            mes: '请先选择供应商类型',
                            timeout: 1500,
                            icon: 'none',
                        })
                    }
                    if(this.choiceIndex!=''&&this.checkedIndex!=''){
                        console.log('打印查看',this.choiceIndex)
                        for(let j in this.form){
                            if(this.choiceIndex==this.form[j].id){
                                this.name = this.form[j].name
                                this.genre = this.form[j].son
                            }
                        }
                        
                    }
                }
            },
            // 选择供应商类型里的分类
            onChecked(id){
                this.checkedIndex = id
            },
            // 关闭弹窗
            onShut(){
                this.isNot = false // 未填写弹窗
                this.isFilled = false // 已填写弹窗
            },
            // 选择供应商类型的上一步
            onBack(){
                this.$router.go(-1);
            },
            // 选择供应商类型的下一步
            onNext(){
                if(this.choiceIndex!=''){
                    this.isSort = false 
                }else{
                    this.$dialog.toast({
                        mes: '请先选择供应商类型',
                        timeout: 1500,
                        icon: 'none',
                    })
                }
                if(this.choiceIndex!=''&&this.checkedIndex!=''){
                    console.log('打印查看',this.choiceIndex)
                    for(let j in this.form){
                        if(this.choiceIndex==this.form[j].id){
                            this.name = this.form[j].name
                            this.genre = this.form[j].son
                        }
                    }
                    
                }
            },
            // 选择供应商类型里的分类的上一步
            onUp(){
                this.isSort = true
                this.checkedIndex =''
            },
            // 获取提示
            getHint(){
                const that = this
                that.$request({
                    that: that,
                    api: that.$api.gettips,
                    data: {},
                    success(res) {
                       that.v = res.data.tips
                    }
                })
            }, 
            // 获取分类
            getForm(){
                const that = this
                that.$request({
                    that: that,
                    api: that.$api.categoryList,
                    data: {},
                    success(res) {
                       that.form = res.data
                    }
                })
            },
            // 提交下一步
            onSubmit(){
                const that = this
                that.$request({
                    that: that,
                    api: that.$api.category,
                    data: {
                        type:that.choiceIndex,
                        subclass:that.checkedIndex,
                    },
                    success(res) {
                        console.log(res)
                        that.$dialog.toast({
                            mes: res.msg,
                            timeout: 1500,
                            icon: 'success',
                            callback(){
                                that.$router.push({ path: '/enterprise',query:{type:that.isType}})
                            }
                        })
                    }
                })
            },
            // 获取审批后详情
            getDetails(){
                const that = this
                that.$request({
                    that: that,
                    api: that.$api.particulars,
                    data: {},
                    success(res) {
                        that.choiceIndex = res.data.type
                        that.checkedIndex = res.data.subclass
                    }
                })
            },
            // 用户信息
            getUser(){
                const that = this
                that.$request({
                    that: that,
                    api: that.$api.consumer,
                    data: {},
                    success(res) {
                       that.user = res.data
                    }
                })
            },
            // 退出
            onQuit(){
                const that = this
                //存储用户登录凭证
                that.$storage.remove('accesstoken')

                //登录成功发起页面跳转
                that.$dialog.toast({
                    mes: '退出登录成功',
                    timeout: 2000,
                    icon: 'success',
                    callback(){
                        that.$router.push({ path: '/logIn' })
                    }
                })
            },
        },
        mounted() {
            const that = this
            that.$store.commit('EditPageData',this.PageData)
            that.getUser()// 用户信息
            that.isType = that.$route.query.type
            if(that.$route.query.type==2){
                that.isFilled = true
                that.isNot = false
                that.getDetails()// 获取审批后详情
            }else{
                that.isNot = true
                that.isFilled = false
            }
            that.getHint() // 获取提示
            that.getForm() // 获取分类
        },
        components:{
            
        },
    }
</script>


// WEBPACK FOOTER //
// src/page/supplier.vue